module.exports = __webpack_public_path__ + "img/D201407_2.0a45ecfa.jpg";